export default {
  root: {
    fontSize: 0
  }
}



// WEBPACK FOOTER //
// ./components/slices/ImageLinks/styles.js